/**
 * 报废
 */
const ScrapRouter = {
  path: '/scrap',
  component: () => import('@/views/layout'),
  redirect: '/administration/scrap/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [{
    path: '/administration/scrap/stockInfo/:id/:type',
    name: 'stockInfo',
    component: () => import('@/views/administration_manage/scrap_manage/stock/stock_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/scrap/termInfo/:id/:type',
    name: 'termInfo',
    component: () => import('@/views/administration_manage/scrap_manage/term/term_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/scrap/assetsInfo/:id/:type',
    name: 'assetsInfo',
    component: () => import('@/views/administration_manage/scrap_manage/assets/assets_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/scrap/myStockInfo/:id/:type',
    name: 'myStockInfo',
    component: () => import('@/views/administration_manage/scrap_manage/myScrap/myStock/my_stock_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/scrap/myTermInfo/:id/:type',
    name: 'myTermInfo',
    component: () => import('@/views/administration_manage/scrap_manage/myScrap/myTerm/my_term_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }, {
    path: '/administration/scrap/myAssetsInfo/:id/:type',
    name: 'myAssetsInfo',
    component: () => import('@/views/administration_manage/scrap_manage/myScrap/myAssets/my_assets_info'),
    hidden: true,
    meta: {
      title: '详情'
    }
  }

  ]
}

export default ScrapRouter
